import globalIP from "@/GlobelIP";

export const checkUserDeviceAccess = async () => {
  try {
    const userId = localStorage.getItem("id");
    const requestIP = localStorage.getItem("user_ip");

    if (!userId || !requestIP) {
      return { success: false, message: "Missing user information" };
    }
    if (requestIP.startsWith("192.")) {
      return {
        success: true,
        message: "Access allowed (Local IP 192.*)"
      };
    }

    // -------------------------------
    // 1️⃣ Fetch user
    // -------------------------------
    const userRes = await fetch(`${globalIP}/api/user-details/${userId}`);
    if (!userRes.ok) {
      return { success: false, message: "Failed to fetch user" };
    }

    const userJson = await userRes.json();
    const user = userJson?.data?.attributes;

    if (!user) {
      return { success: false, message: "User not found" };
    }

    // -------------------------------
    // 2️⃣ Fetch company allowed IPs
    // -------------------------------
    let allowedIPs: string[] = [];

    if (user.Company_Name) {
      const companyRes = await fetch(
        `${globalIP}/api/company-details?filters[cmpcd][$eq]=${user.Company_Name}`
      );

      if (companyRes.ok) {
        const companyJson = await companyRes.json();
        const company = companyJson.data?.[0]?.attributes;

        if (company?.allowedIPs) {
          try {
            allowedIPs = Array.isArray(company.allowedIPs)
              ? company.allowedIPs
              : JSON.parse(company.allowedIPs);
          } catch {
            allowedIPs = [];
          }
        }
      }
    }

    const isLocalNetwork =
      requestIP && allowedIPs.includes(requestIP);

    const isOutsideAllowed =
      user.allowMultipleDevices === true;

    // ------------------------------------------------
    // ✅ RULE 1 — LOCAL NETWORK → ALWAYS ALLOW
    // ------------------------------------------------
    if (isLocalNetwork) {
      return {
        success: true,
        message: "Access allowed (Local Network)"
      };
    }

    // ------------------------------------------------
    // ✅ RULE 2 — OUTSIDE + ALLOW OUTSIDE ACCESS
    // ------------------------------------------------
    if (isOutsideAllowed) {
      return {
        success: true,
        message: "Access allowed (Outside Network)"
      };
    }

    // ------------------------------------------------
    // ✅ RULE 3 — OUTSIDE + EXPIRY CHECK
    // ------------------------------------------------
    if (user.user_expiry_at) {
      const expiry = new Date(user.user_expiry_at);
      const now = new Date();

      if (!isNaN(expiry.getTime()) && now <= expiry) {
        return {
          success: true,
          message: "Access allowed (Temporary Outside Access)",
          expiryAt: user.user_expiry_at
        };
      }
    }

    // ------------------------------------------------
    // ❌ DENY
    // ------------------------------------------------
    return {
      success: false,
      message: "Access denied"
    };

  } catch (err) {
    console.error("🔥 Access check failed:", err);
    return {
      success: false,
      message: "Security check failed"
    };
  }
};
